const HOME_PATH = '/';
const SIGNIN_PATH = '/signin';
const DASHBOARD_PATH = '/dashboard';
const KPI_PATH = '/kpi';
const WORKBENCH_PATH = '/workbench';
const ADMIN_PATH = '/admin';
const ANALYZE_PATH = '/analyze';
const ACTIVITY_PATH = '/activity';
const CONNECTIONS_PATH = '/connections';
const FRAMEWORKS_PATH = '/frameworks';
const PROJECTS_PATH = '/projects';
const RISK_REGISTER_PATH = '/risk-register';
const SEARCH_PATH = '/search';
const AUTHENTICATED_PATH = '/authenticated';
const GROUPS_PATH = '/groups';
const ELEMENTS_PATH = '/elements';
const CONTROLS_PATH = '/controls';
const SUMMARY_PATH = '/summary';
const SECURITY_COVERAGE_PATH = '/security-coverage';
const OPERATING_MODEL_PATH = '/operating-model';
const OPERATING_MODEL_ACCOUNTABILITY_PATH = `${OPERATING_MODEL_PATH}/accountability`;
const OPERATING_MODEL_MANAGEMENT_PATH = `${OPERATING_MODEL_PATH}/management`;
const OPERATING_MODEL_RESOURCES_PATH = `${OPERATING_MODEL_PATH}/resources`;
const OPERATIONAL_EFFICIENCY_PATH = '/operational-efficiency';
const MANAGEMENT_PATH = '/management';
const RESOURCES_PATH = '/resources';
const DASHBOARD_ASSETS_PATH = '/assets';
const PRODUCTIVITY_PATH = '/productivity';
const INTEGRATION_PATH = '/integration';
const INVESTMENT_PATH = '/investment';
const BUDGET_PATH = '/budget';
const LEGACY_BUDGET_PATH = '/zero-based';
const DELTA_PATH = '/delta';
const DELTA_V0_PATH = '/delta-v0';
const DELTA_V1_PATH = '/delta-v1';
const DELTA_V2_PATH = '/delta-v2';
const CHANGE_ANALYSIS_PATH = '/change-analysis';
const STATE_ASSESSMENT_PATH = '/state-assessment';
const CHANGE_ASSESSMENT_PATH = '/change-assessment';
const CHANGE_ASSESSMENT_2_PATH = '/change-assessment-2';

// paths for application apis
const TAGS_PATH = '/tags';
const TAG_PATH = '/tag';
const KPIS_PATH = '/kpis';
const KPI_VALUES_PATH = '/kpi-values';
const KPI_METADATA_PATH = '/kpi-metadata';
const CAPABILITIES_PATH = '/capabilities';
const ASSETS_PATH = '/assets';
const ASSET_PATH = '/asset';
const ASSET_TYPES_PATH = '/asset-types';
const IMPACT_TYPES_PATH = '/impact-types';
const IMPACT_SCALES_PATH = '/impact-scales';
const THREAT_LEVELS_PATH = '/threat-levels';
const THREAT_SURFACES_PATH = '/threat-surfaces';
const THREAT_SURFACE_PATH = '/threat-surface';
const THREAT_SURFACE_TYPES_PATH = '/threat-surface-types';
const ASSET_THREAT_SURFACE_FOOTPRINTS_PATH = '/asset-threat-surface-footprints';
const KPI_GROUPS_PATH = '/kpi-groups';
const CONTROL_PATH = '/control';
const CONTROL_RESOURCES_PATH = '/control-resources';
const CONTROL_RESOURCE_PATH = '/control-resource';
const RESOURCES_API_PATH = '/resources';
const RESOURCE_PATH = '/resource';
const RESOURCE_HISTORY_PATH = '/resource-history';
const RESOURCE_ASSIGNMENTS_PATH = '/resource-assignments';
const RESOURCE_ASSIGNMENT_PATH = '/resource-assignment';
const RESOURCE_ASSIGNMENT_HISTORY_PATH = '/resource-assignment-history';
const RESOURCE_SECURITY_ASSET_LINKS_PATH = '/resource-security-asset-links';
const RESOURCE_SECURITY_ASSET_LINK_PATH = '/resource-security-asset-link';
const PROJECTS_API_PATH = '/projects';
const PROJECT_PATH = '/project';
const PROJECT_CONTROL_LINKS_PATH = '/project-control-links';
const PROJECT_CONTROL_LINK_PATH = '/project-control-link';
const PROJECT_SECURITY_ASSET_LINKS_PATH = '/project-security-asset-links';
const PROJECT_SECURITY_ASSET_LINK_PATH = '/project-security-asset-link';
const CONTROL_SCOPES_PATH = '/control-scopes';
const CONTROL_SCOPE_PATH = '/control-scope';
const CONTROL_BUDGET_TOTALS_PATH = '/control-budget-totals';
const CONTROL_BUDGET_MATRIX_SUMMARY_PATH = '/control-budget-matrix-summary';
const CONTROL_BUDGET_CELL_BREAKDOWN_PATH = '/control-budget-cell-breakdown';
const DELTA_MODELS_PATH = '/delta-models';
const SECURITY_ASSETS_PATH = '/security-assets';
const SECURITY_ASSET_PATH = '/security-asset';
const SECURITY_ASSET_ASSIGNMENTS_PATH = '/security-asset-assignments';
const SECURITY_ASSET_ASSIGNMENT_PATH = '/security-asset-assignment';
const SECURITY_ASSET_NOTES_PATH = '/security-asset-notes';
const SECURITY_ASSET_NOTE_PATH = '/security-asset-note';
const SECURITY_ASSET_ATTACHMENTS_PATH = '/security-asset-attachments';
const SECURITY_ASSET_ATTACHMENT_PATH = '/security-asset-attachment';
const SECURITY_ASSET_HISTORY_PATH = '/security-asset-history';
const PEOPLE_PATH = '/people';
const PERSON_PATH = '/person';
const TEAMS_PATH = '/teams';
const TEAM_PATH = '/team';
const PERSON_CONTROL_RELATIONSHIP_PATH = '/person-control-relationship';
const PERSON_ASSET_RELATIONSHIP_PATH = '/person-asset-relationship';
const PERSON_TIME_SNAPSHOTS_PATH = '/person-time-snapshots';
const PERSON_TIME_SNAPSHOT_PATH = '/person-time-snapshot';
const PERSON_TIME_ALLOCATIONS_PATH = '/person-time-allocations';
const PERSON_CONTROL_TIME_SNAPSHOTS_PATH = '/person-control-time-snapshots';
const PERSON_CONTROL_TIME_SNAPSHOT_PATH = '/person-control-time-snapshot';
const PERSON_CONTROL_TIME_ALLOCATIONS_PATH = '/person-control-time-allocations';
const TOKEN_PATH = '/token';
const COMPANIES_PATH = '/companies';
const COMPANY_PATH = '/company';
const USERS_PATH = '/users';
const USER_PATH = '/user';
const LOGIN_PATH = '/login';
const LOGOUT_PATH = '/logout';
const PASSWORD_PATH = '/password';
const ACTIVITY_ACCOUNT_ANALYSIS_PATH = '/activity/account-analysis';
const FRAMEWORKS_API_PATH = '/frameworks';
const SEARCH_API_PATH = '/search';

export default {
  KNOWLEDGE_BASE: '/knowledge-base',
  INTRO: '/knowledge-base/intro',
  X_DAY: '/knowledge-base/x-day',
  CONTROL_STATS_FALLACY: '/knowledge-base/control-stats-fallacy',
  MEASUREMENT_THAT_MATTERS: '/knowledge-base/measurement-that-matters',
  MATURITY_SCALE: '/knowledge-base/maturity-scale',
  HOME: HOME_PATH,
  SIGNIN: SIGNIN_PATH,
  DASHBOARD: DASHBOARD_PATH,
  KPI: KPI_PATH,
  WORKBENCH: WORKBENCH_PATH,
  ADMIN: ADMIN_PATH,
  ANALYZE: ANALYZE_PATH,
  ACTIVITY: ACTIVITY_PATH,
  CONNECTIONS: CONNECTIONS_PATH,
  FRAMEWORKS: FRAMEWORKS_PATH,
  PROJECTS: PROJECTS_PATH,
  RISK_REGISTER: RISK_REGISTER_PATH,
  SEARCH: SEARCH_PATH,
  AUTHENTICATED: AUTHENTICATED_PATH,
  GROUPS: GROUPS_PATH,
  ELEMENTS: ELEMENTS_PATH,
  CONTROLS: CONTROLS_PATH,
  SUMMARY: SUMMARY_PATH,
  SECURITY_COVERAGE: SECURITY_COVERAGE_PATH,
  OPERATING_MODEL: OPERATING_MODEL_PATH,
  OPERATING_MODEL_ACCOUNTABILITY: OPERATING_MODEL_ACCOUNTABILITY_PATH,
  OPERATING_MODEL_MANAGEMENT: OPERATING_MODEL_MANAGEMENT_PATH,
  OPERATING_MODEL_RESOURCES: OPERATING_MODEL_RESOURCES_PATH,
  OPERATIONAL_EFFICIENCY: OPERATIONAL_EFFICIENCY_PATH,
  MANAGEMENT: MANAGEMENT_PATH,
  RESOURCES: RESOURCES_PATH,
  ASSETS: DASHBOARD_ASSETS_PATH,
  PEOPLE: PEOPLE_PATH,
  PRODUCTIVITY: PRODUCTIVITY_PATH,
  INTEGRATION: INTEGRATION_PATH,
  INVESTMENT: INVESTMENT_PATH,
  BUDGET: BUDGET_PATH,
  LEGACY_BUDGET: LEGACY_BUDGET_PATH,
  DELTA: DELTA_PATH,
  DELTA_V0: DELTA_V0_PATH,
  DELTA_V1: DELTA_V1_PATH,
  DELTA_V2: DELTA_V2_PATH,
  CHANGE_ANALYSIS: CHANGE_ANALYSIS_PATH,
  STATE_ASSESSMENT: STATE_ASSESSMENT_PATH,
  CHANGE_ASSESSMENT: CHANGE_ASSESSMENT_PATH,
  CHANGE_ASSESSMENT_2: CHANGE_ASSESSMENT_2_PATH,

  API: {
    TAGS: TAGS_PATH,
    TAG: TAG_PATH,
    KPIS: KPIS_PATH,
    KPI: KPI_PATH,
    KPI_VALUES: KPI_VALUES_PATH,
    KPI_METADATA: KPI_METADATA_PATH,
    CAPABILITIES: CAPABILITIES_PATH,
    ASSETS: ASSETS_PATH,
    ASSET: ASSET_PATH,
    ASSET_TYPES: ASSET_TYPES_PATH,
    IMPACT_TYPES: IMPACT_TYPES_PATH,
    IMPACT_SCALES: IMPACT_SCALES_PATH,
    THREAT_LEVELS: THREAT_LEVELS_PATH,
    THREAT_SURFACES: THREAT_SURFACES_PATH,
    THREAT_SURFACE: THREAT_SURFACE_PATH,
    THREAT_SURFACE_TYPES: THREAT_SURFACE_TYPES_PATH,
    ASSET_THREAT_SURFACE_FOOTPRINTS: ASSET_THREAT_SURFACE_FOOTPRINTS_PATH,
    KPI_GROUPS: KPI_GROUPS_PATH,
    CONTROLS: CONTROLS_PATH,
    CONTROL: CONTROL_PATH,
    CONTROL_RESOURCES: CONTROL_RESOURCES_PATH,
    CONTROL_RESOURCE: CONTROL_RESOURCE_PATH,
    RESOURCES: RESOURCES_API_PATH,
    RESOURCE: RESOURCE_PATH,
    RESOURCE_HISTORY: RESOURCE_HISTORY_PATH,
    RESOURCE_ASSIGNMENTS: RESOURCE_ASSIGNMENTS_PATH,
    RESOURCE_ASSIGNMENT: RESOURCE_ASSIGNMENT_PATH,
    RESOURCE_ASSIGNMENT_HISTORY: RESOURCE_ASSIGNMENT_HISTORY_PATH,
    RESOURCE_SECURITY_ASSET_LINKS: RESOURCE_SECURITY_ASSET_LINKS_PATH,
    RESOURCE_SECURITY_ASSET_LINK: RESOURCE_SECURITY_ASSET_LINK_PATH,
    PROJECTS: PROJECTS_API_PATH,
    PROJECT: PROJECT_PATH,
    PROJECT_CONTROL_LINKS: PROJECT_CONTROL_LINKS_PATH,
    PROJECT_CONTROL_LINK: PROJECT_CONTROL_LINK_PATH,
    PROJECT_SECURITY_ASSET_LINKS: PROJECT_SECURITY_ASSET_LINKS_PATH,
    PROJECT_SECURITY_ASSET_LINK: PROJECT_SECURITY_ASSET_LINK_PATH,
    CONTROL_SCOPES: CONTROL_SCOPES_PATH,
    CONTROL_SCOPE: CONTROL_SCOPE_PATH,
    CONTROL_BUDGET_TOTALS: CONTROL_BUDGET_TOTALS_PATH,
    CONTROL_BUDGET_MATRIX_SUMMARY: CONTROL_BUDGET_MATRIX_SUMMARY_PATH,
    CONTROL_BUDGET_CELL_BREAKDOWN: CONTROL_BUDGET_CELL_BREAKDOWN_PATH,
    DELTA_MODELS: DELTA_MODELS_PATH,
    SECURITY_ASSETS: SECURITY_ASSETS_PATH,
    SECURITY_ASSET: SECURITY_ASSET_PATH,
    SECURITY_ASSET_ASSIGNMENTS: SECURITY_ASSET_ASSIGNMENTS_PATH,
    SECURITY_ASSET_ASSIGNMENT: SECURITY_ASSET_ASSIGNMENT_PATH,
    SECURITY_ASSET_NOTES: SECURITY_ASSET_NOTES_PATH,
    SECURITY_ASSET_NOTE: SECURITY_ASSET_NOTE_PATH,
    SECURITY_ASSET_ATTACHMENTS: SECURITY_ASSET_ATTACHMENTS_PATH,
    SECURITY_ASSET_ATTACHMENT: SECURITY_ASSET_ATTACHMENT_PATH,
    SECURITY_ASSET_HISTORY: SECURITY_ASSET_HISTORY_PATH,
    PEOPLE: PEOPLE_PATH,
    PERSON: PERSON_PATH,
    TEAMS: TEAMS_PATH,
    TEAM: TEAM_PATH,
    PERSON_CONTROL_RELATIONSHIP: PERSON_CONTROL_RELATIONSHIP_PATH,
    PERSON_ASSET_RELATIONSHIP: PERSON_ASSET_RELATIONSHIP_PATH,
    PERSON_TIME_SNAPSHOTS: PERSON_TIME_SNAPSHOTS_PATH,
    PERSON_TIME_SNAPSHOT: PERSON_TIME_SNAPSHOT_PATH,
    PERSON_TIME_ALLOCATIONS: PERSON_TIME_ALLOCATIONS_PATH,
    PERSON_CONTROL_TIME_SNAPSHOTS: PERSON_CONTROL_TIME_SNAPSHOTS_PATH,
    PERSON_CONTROL_TIME_SNAPSHOT: PERSON_CONTROL_TIME_SNAPSHOT_PATH,
    PERSON_CONTROL_TIME_ALLOCATIONS: PERSON_CONTROL_TIME_ALLOCATIONS_PATH,
    TOKEN: TOKEN_PATH,
    COMPANIES: COMPANIES_PATH,
    COMPANY: COMPANY_PATH,
    USERS: USERS_PATH,
    USER: USER_PATH,
    LOGIN: LOGIN_PATH,
    LOGOUT: LOGOUT_PATH,
    PASSWORD: PASSWORD_PATH,
    ACTIVITY_ACCOUNT_ANALYSIS: ACTIVITY_ACCOUNT_ANALYSIS_PATH,
    FRAMEWORKS: FRAMEWORKS_API_PATH,
    SEARCH: SEARCH_API_PATH,
  },
};
